import type { ReactNode } from 'react';

import { useState } from 'react';
import { EllipsisVertical } from 'lucide-react';

import { Menu, MenuItem, IconButton } from '@mui/material';

export type ItemMenuAction = { key: string; label: string; icon: ReactNode; run: () => void };

export function DocumentsItemMenu({ label, actions }: { label: string; actions: ItemMenuAction[] }) {
  const [anchorEl, setAnchorEl] = useState<HTMLElement | null>(null);
  const close = () => setAnchorEl(null);

  return (
    <>
      <IconButton
        aria-label={label}
        size="small"
        onClick={(e) => {
          e.stopPropagation();
          setAnchorEl(e.currentTarget);
        }}
      >
        <EllipsisVertical size={16} strokeWidth={2} />
      </IconButton>
      <Menu
        anchorEl={anchorEl}
        open={Boolean(anchorEl)}
        onClose={close}
        // The menu is in a portal. Its events still reach the card, and a long press there selects the card.
        onClick={(e) => e.stopPropagation()}
        onTouchStart={(e) => e.stopPropagation()}
        onTouchMove={(e) => e.stopPropagation()}
        onTouchEnd={(e) => e.stopPropagation()}
      >
        {actions.map((action) => (
          <MenuItem
            key={action.key}
            onClick={() => {
              action.run();
              close();
            }}
            sx={{ gap: 1 }}
          >
            {action.icon}
            {action.label}
          </MenuItem>
        ))}
      </Menu>
    </>
  );
}
